import "core-js/modules/es.string.bold.js";
import React from 'react';
import cn from 'classnames';
import { useTheme, ThemeProvider } from '@rescui/ui-contexts';
import styles from './form-trigger.p.module.css.js';
var SIZE_STYLES = {
  l: styles.sizeL,
  m: styles.sizeM,
  s: styles.sizeS
};
var THEME_STYLES = {
  light: styles.themeLight,
  dark: styles.themeDark
};

var Label = function Label(_ref) {
  var children = _ref.children,
      size = _ref.size,
      boldLabel = _ref.boldLabel;

  if (!children) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: cn(styles.label, boldLabel && styles.bold)
    }, children);
  }
};

var FormTriggerWrapper = function FormTriggerWrapper(_ref2) {
  var size = _ref2.size,
      themeFromProps = _ref2.theme,
      className = _ref2.className,
      error = _ref2.error,
      label = _ref2.label,
      note = _ref2.note,
      children = _ref2.children,
      onKeyDown = _ref2.onKeyDown,
      boldLabel = _ref2.boldLabel;
  var theme = useTheme(themeFromProps);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(className, SIZE_STYLES[size], THEME_STYLES[theme]),
    "data-test": "select-wrapper"
  }, /*#__PURE__*/React.createElement(Label, {
    boldLabel: boldLabel,
    size: size
  }, label), /*#__PURE__*/React.createElement("div", {
    onKeyDown: onKeyDown
  }, children), error && /*#__PURE__*/React.createElement("div", {
    className: styles.errorMessage
  }, error), note && /*#__PURE__*/React.createElement("div", {
    className: styles.note
  }, note)));
};

export { FormTriggerWrapper as default };
